module.exports = require("mz");


//////////////////
// WEBPACK FOOTER
// external "mz"
// module id = 19
// module chunks = 0